import { ref, watchEffect } from 'vue'
import { useTranslate } from '@/shared/lib'
import { cloneDeep } from 'lodash'
import { useLoadCabinetReportInventory } from './api'

const useModel = () => {
  const data = ref<any[]>([])
  const total = ref(0)

  const { trs } = useTranslate()

  const headers = ref<any>([
    { title: '№', key: 'index', sortable: false },
    { title: trs('itf.name'), key: 'name', sortable: false },
    { title: trs('itf.serial_number'), key: 'serial_number', sortable: false },
    { title: trs('itf.meter_type'), key: 'meter_type', sortable: false },
    { title: trs('itf.mater_number'), key: 'meter_serial_number', sortable: false },
    { title: trs('itf.sim_num', { num: 1 }), key: 'sim_1', sortable: false },
    { title: trs('itf.iccid_sim_num', { num: 1 }), key: 'iccid_sim_1', sortable: false },
    { title: trs('itf.sim_num', { num: 2 }), key: 'sim_2', sortable: false },
    { title: trs('itf.iccid_sim_num', { num: 2 }), key: 'iccid_sim_2', sortable: false },
    { title: trs('itf.contactors'), key: 'contactors_count', sortable: false },
    { title: trs('itf.protect'), key: 'protects_count', sortable: false },
  ])

  /**
   * Функция загрузки таблицы
   */
  const loadTable = (filter: any) => {
    const result = useLoadCabinetReportInventory(filter)

    watchEffect(() => {
      if (result.data.value) {
        /** Выставляем значения по умолчанию для null */
        data.value = cloneDeep(result.data.value.data || []).map((item: any) => {
          for (let prop in item) {
            item[prop] = item[prop] === null ? '-' : item[prop]
          }

          return item
        })

        total.value = data.value.length
      }
    })

    return result
  }

  return {
    data,
    headers,
    total,

    loadTable,
  }
}

export default useModel
